<template>
  <div class="mopc-total">
    <span v-if="showProratedCharge">
      <i v-if="isLoadingTax" class="zm-icon-loading" />
      <span v-else class="mopc-total__content">{{ this.$money(this.getProratedChargeTotalAmount) }}</span>
    </span>
    <span v-else-if="isShowTax && isTaxEstimatedBefore">
      <i v-if="isLoadingTax" class="zm-icon-loading" />
      <span v-else class="mopc-total__content">{{ this.$money(includeTaxTotalAmount) }}</span>
    </span>
    <span v-else>
      <!-- for new figma design, remove before taxes, only show in modal page -->
     <span class="mopc-total__label" v-if="showBeforeTaxes">({{ $t('billing.common.before_taxes') }})</span>
      <span class="mopc-total__content">{{ this.$money(beforeTaxTotalAmount) }}</span>
    </span>
  </div>
</template>

<script>
import Total from './total.vue';
import { mapGetters } from 'vuex';
export default {
  mixins: [Total],
  computed: {
    ...mapGetters(['getTotalCharge', 'openInvoiceTotalAmount', 'includeTaxTotalAmount', 'beforeTaxTotalAmount']),
  },
  props: {
    showBeforeTaxes: {
      type: Boolean,
      defalut: false
    }
  }
};
</script>

<style lang="scss" scoped>
.mopc-total {
  display: flex;
  &__label {
    color: #666487;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  &__content {
    padding-left: 0.5rem;
    color: #00053d;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }
}
</style>
